import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/AssetTransferReport/Filter'

export default createListViewComponent({
  entityName: entityNames.assetTransferReport,
  filterTemplateType: 'AssetTransferReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
})(Filter)
